import axios from "../../axios";

const urlBlog = "/page-blogs";

const state = {
  blogs: [],
  blog: null,
};

const actions = {
  /**
   * getListBlogs
   * @param commit
   * @param query
   * @returns {Promise<void>}
   */
  async getListBlogs({ commit }, query) {
    const response = await axios.get(
      `${urlBlog}?${new URLSearchParams(query)}`,
    );
    if (response.status === 200) {
      commit("SET_LIST_BLOGS", response.data.data);
    }

    return response;
  },

  async getDetailBlog({ commit }, { id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${urlBlog}/${id}?${new URLSearchParams(payload)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response.data ?? {});
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  /**
   * createPage
   * @param commit
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async createBlog({ commit }, payload) {
    return await axios.post(urlBlog, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  /**
   * updatePage
   * @param commit
   * @param id
   * @param payload
   * @returns {Promise<AxiosResponse<any>>}
   */
  async updateBlog({ commit }, { id, payload }) {
    const response = await axios.post(`${urlBlog}/${id}`, payload, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    if (response.status === 200) {
      commit("SET_DETAIL", response.data.data);
    }

    return response;
  },

  // eslint-disable-next-line no-unused-vars
  async patchUpdateBlog({ commit }, { id, payload }) {
    const response = await axios.patch(`${urlBlog}/${id}`, payload);

    return response;
  },

  /**
   * deletePage
   * @param commit
   * @param id
   * @returns {Promise<AxiosResponse<any>>}
   */
  // eslint-disable-next-line no-unused-vars
  async deleteBlog({ commit }, id) {
    const response = await axios.delete(`${urlBlog}/${id}`);

    if (response.status === 200) {
      commit("DELETE_BLOG", id);
    }

    return response;
  },
};

const mutations = {
  SET_LIST_BLOGS(state, data) {
    console.log("response.data.data");
    console.log(data);
    state.blogs = data;
  },

  SET_DETAIL(state, data) {
    state.blog = data;
  },

  DELETE_BLOG(state, id) {
    const index = state.blogs.findIndex((u) => u.id === id);

    if (index >= 0) {
      state.blogs.splice(index, 1);
    }
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
